import {
  FMSLocationData,
  FMSSyncedLocationData,
  FMSType,
  GetOrCreateUserInterface,
  LeadInterface,
  LeaseInterface,
  SaveTenantInterface,
  SaveUnitInterface,
  TenantInterface,
  UnitInterface,
  UserInterface,
} from "@swivl-mono/types";

import { APIService } from "../Service/API.Service";

//LINK - apps/sync/src/API/SyncFMS/SyncFMS.Controller.ts
export class SyncAPI {
  static async fmsQueueLocations() {
    return APIService.Sync.post<FMSLocationData[]>("/sync/fms/queue/locations", {});
  }

  static async fmsSyncLocation(location: FMSLocationData) {
    return APIService.Sync.post<FMSSyncedLocationData>("/sync/fms/location", location);
  }

  static async getFMSLocationData(fmsType?: FMSType) {
    return APIService.Sync.get<FMSLocationData[]>(`/synchronization/location-data`, fmsType ? { fmsType } : undefined);
  }

  static async getLeadsByLocationId(orgId: number, locationId: number) {
    return APIService.Sync.get<LeadInterface[]>(`/synchronization/org/${orgId}/location/${locationId}/leads`);
  }

  static async getUnitsByLocationId(orgId: number, locationId: number, params?: { available?: boolean }) {
    return APIService.Sync.get<UnitInterface[]>(`/synchronization/org/${orgId}/location/${locationId}/units`, params);
  }

  static async createLeads(orgId: number, leads?: Partial<LeadInterface>[]) {
    return APIService.Sync.post<LeadInterface[]>(`/synchronization/org/${orgId}/leads`, leads);
  }

  static async updateLeads(orgId: number, leads: Partial<LeadInterface>[]) {
    return APIService.Sync.put<LeadInterface[]>(`/synchronization/org/${orgId}/leads`, leads);
  }

  static async deleteLeads(orgId: number, leadIds: number[]) {
    return APIService.Sync.delete<LeadInterface[]>(`/synchronization/org/${orgId}/leads`, null, leadIds);
  }

  static async getLeasesByLocationId(orgId: number, locationId: number) {
    return APIService.Sync.get<LeaseInterface[]>(`/synchronization/org/${orgId}/location/${locationId}/leases`);
  }

  static async getTenantsByLocationId(orgId: number, locationId: number) {
    return APIService.Sync.get<TenantInterface[]>(`/synchronization/org/${orgId}/location/${locationId}/tenants`);
  }

  static async updateLeases(orgId: number, leases: Partial<LeaseInterface>[]) {
    return APIService.Sync.put<LeaseInterface[]>(`/synchronization/org/${orgId}/leases`, leases);
  }

  static async createLeases(orgId: number, leases?: Partial<LeaseInterface>[]) {
    return APIService.Sync.post<LeaseInterface[]>(`/synchronization/org/${orgId}/leases`, leases);
  }

  static async deleteLeases(orgId: number, leaseIds: number[]) {
    return APIService.Sync.delete<LeaseInterface[]>(`/synchronization/org/${orgId}/leases`, null, leaseIds);
  }

  static async updateUsersDependencies(orgId: number, usersPartial: Partial<UserInterface>[]) {
    return APIService.Sync.put<UserInterface[]>(`/synchronization/org/${orgId}/users-dependencies`, usersPartial);
  }

  static async getOrCreateUserByPhoneNumber(orgId: number, phoneNumber: string, createdBy?: string) {
    const params: any = { phoneNumber };
    if (createdBy && createdBy.trim()) {
      params.createdBy = createdBy;
    }
    return APIService.Sync.get<GetOrCreateUserInterface>(`/synchronization/org/${orgId}/user`, params);
  }

  static async updateUser(orgId: number, userId: number, user: Partial<UserInterface>) {
    return APIService.Sync.put<UserInterface>(`/synchronization/org/${orgId}/user/${userId}`, user);
  }

  static async createTenants(orgId: number, tenants?: SaveTenantInterface[]): Promise<TenantInterface[]> {
    if (!tenants || !tenants.length) {
      return [];
    }

    const batchSize = 500;
    if (tenants.length > batchSize) {
      const tenantBatches: SaveTenantInterface[][] = [];
      for (let i = 0; i < tenants.length; i += batchSize) {
        tenantBatches.push(tenants.slice(i, i + batchSize));
      }
      const tenantsResponse = await Promise.all(tenantBatches.map((batch) => this.createTenants(orgId, batch)));
      return tenantsResponse.flat();
    }

    return APIService.Sync.post<TenantInterface[]>(`/synchronization/org/${orgId}/tenants`, tenants);
  }

  static async updateTenants(orgId: number, tenants: SaveTenantInterface[]) {
    return APIService.Sync.put<TenantInterface[]>(`/synchronization/org/${orgId}/tenants`, tenants);
  }

  static async deleteTenants(orgId: number, tenantIds: number[]) {
    return APIService.Sync.delete<TenantInterface[]>(`/synchronization/org/${orgId}/tenants`, null, tenantIds);
  }

  static async createUnits(orgId: number, units?: SaveUnitInterface[]) {
    return APIService.Sync.post<UnitInterface[]>(`/synchronization/org/${orgId}/units`, units);
  }

  static async updateUnits(orgId: number, units: SaveUnitInterface[]) {
    return APIService.Sync.put<UnitInterface[]>(`/synchronization/org/${orgId}/units`, units);
  }

  static async deleteUnits(orgId: number, unitIds: number[]) {
    return APIService.Sync.delete<UnitInterface[]>(`/synchronization/org/${orgId}/units`, null, unitIds);
  }

  static async syncReviews(syncAll: boolean) {
    return APIService.Sync.get<boolean>(`/reviews/sync/${syncAll}`);
  }

  static async triggerReviewAutoReplies() {
    return APIService.Sync.get<boolean>(`/reviews/generate-auto-replies`);
  }
}
